const DELTA = 0.125;
let maps;

function boundsExtender(bounds, { lat, lon }) {
  return isNaN(lat) || isNaN(lon)
    ? bounds
    : bounds.extend(new maps.LatLng(lat, lon));
}

const parseResult = ({ lat, lon }) => ({ lat: parseFloat(lat), lon: parseFloat(lon) });

const boundsReducer = (bounds, result) => boundsExtender(bounds, parseResult(result));

function setMaps() {
  maps = maps || (window.google && window.google.maps);
}

function newMapBounds(results) {
  setMaps();
  let bounds = null;

  if (maps) {
    // Create the bounds from all the results markers
    bounds = results.reduce(boundsReducer, new maps.LatLngBounds());

    if (results.length === 1) { // expand bounds from point to rectangle
      const { lat, lon } = parseResult(results[0]);

      boundsExtender(bounds, { lat: lat - DELTA, lon: lon - (2 * DELTA) }); // extend SW
      boundsExtender(bounds, { lat: lat + DELTA, lon: lon + (2 * DELTA) }); // extend NE
    }
  }

  return bounds;
}

export default newMapBounds;



// WEBPACK FOOTER //
// ./services/MapsService.js